module.exports = __webpack_public_path__ + "img/mac.724e0b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mac.png
// module id = 8RCY
// module chunks = 39 44